// On cleanor.app the sign-in handler is proxied from our own origin (next.config.mjs
// rewrites /__/auth), so the popup and the page share storage. Requires
// https://cleanor.app/__/auth/handler as an authorized redirect URI in the Google OAuth
// client and the Meta app (both added 2026-10-07); a provider without it fails with
// redirect_uri_mismatch.
const SAME_ORIGIN_HOSTS = new Set(['cleanor.app', 'www.cleanor.app']);
function resolveAuthDomain() {
  const configured = process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN?.trim();
  if (
    process.env.NEXT_PUBLIC_FIREBASE_SAME_ORIGIN_AUTH === '1' &&
    typeof window !== 'undefined' &&
    SAME_ORIGIN_HOSTS.has(window.location.hostname)
  ) {
    return window.location.hostname;
  }
  return configured;
}

export const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY?.trim(),
  authDomain: resolveAuthDomain(),
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID?.trim(),
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET?.trim(),
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID?.trim(),
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID?.trim(),
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID?.trim(),
};

export const firebaseEnabled = Object.values(firebaseConfig).every(Boolean);

export const firebaseProjectName = 'Cleanor Web';
